export const usernameNotFound = 'That user does not exist.';

// It's different for recentSubmissions for some reason
export const usernameNotFoundAlt = 'User matching query does not exist.'
